var _linearGradient, _path, _circle, _circle2, _linearGradient2, _path2, _path3, _linearGradient3, _circle3, _linearGradient4, _circle4, _path4, _path5, _linearGradient5, _path6, _path7, _path8, _linearGradient6, _path9, _path10, _linearGradient7, _path11, _path12, _linearGradient8, _path13, _path14, _path15, _linearGradient9, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFixedAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: -2105.018,
    y1: -247.104,
    x2: -2104.018,
    y2: -247.104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M155.44 131.07h-33.262M106.424 131.07h-11.83v-18.527l12.372-4.256 8-19.534h61.186l3 19.822v22.495h-7.768"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 114.301,
    cy: 131.07,
    r: 7.877
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 163.317,
    cy: 131.07,
    r: 7.877
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: 111.855,
    y1: 101.171,
    x2: 134.971,
    y2: 101.171
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M118.814 94.276l-5.709 13.79h20.616v-13.79z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M129.105 112.939h4.651"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: 110.038,
    y1: 131.07,
    x2: 118.564,
    y2: 131.07
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.301,
    cy: 131.07,
    r: 3.013,
    fill: "none",
    stroke: "url(#SVGID_2_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: 159.055,
    y1: 131.253,
    x2: 167.58,
    y2: 131.253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.317,
    cy: 131.253,
    r: 3.013,
    fill: "none",
    stroke: "url(#SVGID_3_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M32.571 91.753h32.054v28.238H32.571z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M87.695 92.021v13.768"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: 75.823,
    y1: 98.812,
    x2: 99.568,
    y2: 98.812
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M77.073 91.753h21.245v14.119H77.073z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M94.594 119.991H24.372V25.972h47.294l.046 22.803h69.03v39.978"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M87.585 62.966v13.767"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: 75.712,
    y1: 70.025,
    x2: 99.457,
    y2: 70.025
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M76.962 62.966h21.245v14.119H76.962z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M121.622 62.79v13.767"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: 109.75,
    y1: 69.849,
    x2: 133.494,
    y2: 69.849
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M111 62.79h21.245v14.119H111z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M54.003 62.878v13.767M43.416 63.007v13.767"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: 31.321,
    y1: 69.937,
    x2: 65.876,
    y2: 69.937
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M32.571 62.878h32.054v14.119H32.571z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M48.599 92.104v27.616M71.715 41.467h74.879v7.308H71.715z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M53.489 34.726v13.768M42.903 34.856v13.767"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2",
    gradientUnits: "userSpaceOnUse",
    x1: 30.807,
    y1: 41.786,
    x2: 65.362,
    y2: 41.786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_e400abb98133987a65eeaedb70fbb04979916d61518f93a4af3088a5282c40a2)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M32.057 34.726h32.054v14.119H32.057z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M18.366 18.597h59.14v7.308h-59.14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixedAsset);
export default __webpack_public_path__ + "static/media/fixedAsset.3aa036a11a5f441109ab3ea780489caf.svg";
export { ForwardRef as ReactComponent };